export const useSetTitle = () => {
  return (title?: string) => {
    document.title = title ? `Syla - ${title}` : "Syla";
  };
};
